module.exports = __webpack_public_path__ + "media/images/delete-icon-1edd7a1a53625f877041d452b4540e0d.png";